import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Link} from 'gatsby';

function Cutttingedge(props) {
    return (
        <div className="p-100 tekrevol_dark_bg">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                        <div className="example center text-center" data-text="App">
                            <h2>We're excited to assist you in reaching your objectives and converting them into a high-quality digital solution. Claim your free consultation now!</h2>
                        </div>
                        <Link to="https://www.tekrevol.com/contact"
                              className="border_btn " aria-label="TekRevol Contact">Book a Consultation now!</Link>
                    <p className="mt-4">Or, drop your details in this form to share your requirements.</p>          
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Cutttingedge;